module.exports = __webpack_public_path__ + "static/media/checkmark-2-2.b2a659e2.svg";